import { render } from "./MultipleChoiceArray.vue?vue&type=template&id=0d6ec644"
import script from "./MultipleChoiceArray.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceArray.vue?vue&type=script&lang=js"

import "./MultipleChoiceArray.vue?vue&type=style&index=0&id=0d6ec644&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__